/**
 * Select a route only after the authenticated role has been checked.
 *
 * Keep this function free of React and module imports: a denied route must not
 * even read its loader from the route table, so the browser cannot start a
 * forbidden chunk request while App redirects the hash.
 */
export function resolveRoleRoute<TRole extends PropertyKey, TSection extends PropertyKey, TRoute>(
  role: TRole,
  section: TSection,
  allowedSections: Readonly<Record<TRole, readonly TSection[]>>,
  routes: Readonly<Partial<Record<TSection, TRoute>>>,
): TRoute | null {
  const permitted = allowedSections[role];
  if (!permitted?.includes(section)) return null;
  return routes[section] ?? null;
}
